'use client'

import { lazy } from 'react'

// The server footer has its own Suspense boundary. Preserve its SSR content
// without adding its behavior to the header's initial script requests.
const LocaleSwitcher = lazy(() => import('./locale-switcher').then((module) => ({ default: module.LocaleSwitcher })))

export const LocaleSwitcherLazy = () => <LocaleSwitcher />
